import MediaPreview from 'components/mediaPreview/mediaPreview.module';
import { MessageWrapper } from 'components/messageWrapper/messageWrapper.module';
import { MESSAGE_SENDER, MESSAGE_TYPE } from 'consts/enum';
import { generate6DigitUUID } from 'helpers/helpers';
import { imageData } from './sendImage.model';
import { SendImageTemplate } from './sendImage.template';

const { BOT, AGENT } = MESSAGE_SENDER;
export default class SendImage {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEventHandlers();
	}

	initData(propData = {}) {
		this.data = imageData;
		const { sender } = propData;
		const { image_url, alt_text, message_text, enable_download } = propData.message?.data;
		this.setter({
			...propData,
			sender,
			imageUrl: image_url,
			altText: alt_text,
			messageText: message_text,
			enableDownload: enable_download,
			id: propData.message_id || generate6DigitUUID(),
		});
	}

	initWrapper() {
		const { sender = BOT } = this.data;
		const wrapper = document.createElement('div');
		wrapper.classList.add('engt-msg', `engt-msg-${sender}`, `engt-msg-border-${sender}`, 'engt-msg-image');
		wrapper.innerHTML = SendImageTemplate({
			...this.data,
			showText: true,
		});

		this.html = wrapper;
	}

	initComponents() {
		const { sender = BOT } = this.data;

		this.html = new MessageWrapper({
			...this.data,
			message: MESSAGE_TYPE.IMAGE,
			innerHTML: this.html.outerHTML,
			download: this.data.enableDownload,
			downloadLink: this.data.imageUrl,
		});
	}

	initEventHandlers() {
		const { id } = this.data;
		this.html.querySelector(`#engtImage-${id}`).addEventListener('click', () => {
			new MediaPreview({
				id: this.data.id,
				type: MESSAGE_TYPE.IMAGE,
				children: SendImageTemplate({ ...this.data, showText: false }),
			}).render();
		});
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
